import React, { ChangeEvent, forwardRef } from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { useUncontrolled } from '@affstore-ds/helpers'
import { TextInput } from '@affstore-ds/uikit'

import { affTrackSearchRegExp } from '../../shared/constants'
import { AffTrackInputPropertiesInterface, AffTrackInputPropertiesType } from './AffTrackInput.types'
import { AffTrackSelectTranslationKeys } from './translations/AffTrackSelect.translationKeys'

export const AffTrackInput: AffTrackInputPropertiesType = forwardRef<HTMLInputElement, AffTrackInputPropertiesInterface>(
  ({ label, defaultValue, onChange, value: formValue, ...rest }, reference) => {
    const [value, setValue] = useUncontrolled({
      defaultValue,
      onChange,
      value: formValue,
    })
    const { i18n } = useI18n()

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      const preparedSearchValue = event.target.value.replace(affTrackSearchRegExp, '')

      setValue(preparedSearchValue)
    }

    return (
      <TextInput
        data-testid="afftrack-input"
        label={label || i18n.t(AffTrackSelectTranslationKeys.statisticsAfftrackLabel)}
        labelIconTooltipText={i18n.t(AffTrackSelectTranslationKeys.statisticsAfftrackLabelTooltip)}
        onChange={handleChange}
        placeholder={i18n.t(AffTrackSelectTranslationKeys.statisticsAfftrackPlaceholder)}
        ref={reference}
        value={value}
        {...rest}
      />
    )
  },
)

AffTrackInput.displayName = 'AffTrackInput'
